import { Mail, ChevronRight, BarChart3, Zap } from "lucide-react";

// Realistic marketing email preview component
const EmailPreview = () => {
  const heroImage = "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=400&h=200&fit=crop";

  return (
    <div
      className="relative overflow-hidden flex flex-col bg-white"
      style={{
        width: '180px',
        borderRadius: '12px',
        boxShadow: '0 8px 30px rgba(0, 0, 0, 0.12), 0 4px 12px rgba(0, 0, 0, 0.08)',
      }}
    >
      {/* Email Header */}
      <div className="px-3 py-2.5 border-b border-gray-100">
        <div className="flex items-center gap-2 mb-1">
          <div className="w-5 h-5 rounded-full bg-grow/20 flex items-center justify-center">
            <span className="text-[8px] font-bold text-grow">CM</span>
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-1">
              <span className="text-[9px] font-semibold text-gray-900 truncate">Café Milano</span>
              <svg className="w-2.5 h-2.5 text-blue-500 shrink-0" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
            </div>
            <p className="text-[7px] text-gray-400">to me</p>
          </div>
        </div>
        <p className="text-[10px] font-medium text-gray-800 leading-tight">
          Your exclusive offer is waiting!
        </p>
      </div>

      {/* Hero Image */}
      <div className="w-full overflow-hidden" style={{ aspectRatio: '180/80' }}>
        <img
          src={heroImage}
          alt="Coffee"
          className="w-full h-full object-cover"
        />
      </div>

      {/* Email Content */}
      <div className="px-3 py-3 space-y-2.5">
        {/* Headline */}
        <div className="text-center">
          <p className="text-[11px] font-bold text-gray-900 leading-tight">
            20% Off Your Next Visit
          </p>
          <p className="text-[8px] text-gray-500 mt-0.5">
            As a valued customer, enjoy this exclusive reward
          </p>
        </div>

        {/* CTA Button */}
        <button
          className="w-full py-1.5 px-3 rounded-md bg-grow text-white text-[9px] font-semibold flex items-center justify-center gap-1 hover:bg-grow/90 transition-colors"
        >
          Claim Offer
          <ChevronRight className="w-3 h-3" />
        </button>

        {/* Footer with stats */}
        <div className="flex items-center justify-center gap-3 pt-1 border-t border-gray-50">
          <div className="flex items-center gap-1 text-[7px] text-gray-400">
            <BarChart3 className="w-2.5 h-2.5" />
            <span>65% opened</span>
          </div>
          <div className="flex items-center gap-1 text-[7px] text-gray-400">
            <Zap className="w-2.5 h-2.5" />
            <span>Automated</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export const EmailMarketingVisualization = () => {
  return (
    <div className="relative w-full h-full min-h-[280px] flex items-center justify-center">
      {/* Floating email preview with subtle animation */}
      <div className="relative animate-bento-float">
        {/* Email type label */}
        <div className="absolute -top-6 left-1/2 -translate-x-1/2">
          <div className="flex items-center gap-1.5 px-2 py-0.5 rounded-full bg-grow/10 border border-grow/20">
            <Mail className="w-2.5 h-2.5 text-grow" />
            <span className="text-[8px] font-medium text-grow">Campaign Email</span>
          </div>
        </div>

        <EmailPreview />
      </div>
    </div>
  );
};
